import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationStackCreateFromIntentArgs, Stack } from "types/generated";

export const STACK_CREATE_FROM_INTENT: TypedDocumentNode<
  { stackCreateFromIntent: Pick<Stack, "id"> },
  MutationStackCreateFromIntentArgs
> = gql`
  mutation StackCreateFromIntent($project: ID!, $stackName: String, $importState: Boolean) {
    stackCreateFromIntent(project: $project, stackName: $stackName, importState: $importState) {
      id
    }
  }
`;
